// 회원기본 정보 등록

// import { getFormData, regEmail } from "components/utils/comm";
// import { FormEvent } from "react";
import { useJoinBaseCreateMutate } from "./service";
import useAlertStore from "store/alert";
import { useBaseJoinParamContext } from "./context";

export const useJoinBaseCreate = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { param } = useBaseJoinParamContext();
  const { mutate } = useJoinBaseCreateMutate();

  const onSubmit = (form: HTMLFormElement) => {
    // ❌ validation 실패
    if (!form.checkValidity()) {
      form.reportValidity(); // required 문구 표시
      return;
    }

    onSetAlert({
      isOpen: true,
      inner: "회원기본정보를 등록하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: () => {
        mutate(param);
      },
    });
  };

  return {
    onSubmit,
  };
};
